(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('PublicNorma', PublicNorma);

    PublicNorma.$inject = ['$resource', 'DateUtils'];

    function PublicNorma ($resource, DateUtils) {
        var resourceUrl =  'public/api/normas/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data,headers) {

                    var data_response = {};
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaEmision = DateUtils.convertDateTimeFromServer(data.fechaEmision);
                        data.fechaPublicacion = DateUtils.convertDateTimeFromServer(data.fechaPublicacion);

                    }

                    return data;
                }
            },
            'getDocuments': {
                url: resourceUrl + '/documentos',
                method: 'GET',
                isArray: true
            },
            'getHistorial': {
                url: resourceUrl + '/historial',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
